import { FunctionalComponent, h } from 'preact';

import { IconTemplatePropsInterface } from './template-props.interface';

export const IconEmptyState: FunctionalComponent<IconTemplatePropsInterface> = (props) => (
  <svg
    className={props.class}
    width='125'
    height='125'
    viewBox='0 0 110 110'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z'
      fill='#D2E7ED'
    />
    {/* eslint-disable-next-line react/no-unknown-property */}
    <mask id='mask0' mask-type='alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='110' height='110'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M55 110C85.3757 110 110 85.3757 110 55C110 24.6243 85.3757 0 55 0C24.6243 0 0 24.6243 0 55C0 85.3757 24.6243 110 55 110Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.76 28.16L37.6874 36.2282C37.6874 36.2282 35.8944 38.2383 32.6619 39.359C29.4295 40.4796 24.6566 40.48 24.6566 40.48H-19.4033V66.9406H50.4709L47.9002 28.16H45.76Z'
        fill='#D6C7C7'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.76 44.2601C45.76 44.2601 45.7355 49.4527 44.7611 52.1798C43.7868 54.9069 41.0302 57.4987 41.0302 57.4987L38.4514 60.0604C38.4514 60.0604 34.9431 62.6876 32.2926 63.8296C29.642 64.9716 24.6438 65.1281 24.6438 65.1281H-15.8402L-15.6742 107.09L14.6203 123.003L70.3145 121.681L80.9064 79.2314L66.8556 62.6876L45.76 44.2601Z'
        fill='url(#paint0_linear)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M45.76 28.16C45.76 28.16 45.76 31.0965 45.76 45.1659C45.76 52.8 45.76 52.8 58.2584 65.0508C62.0595 68.7766 66.126 72.2253 66.126 77.5415C66.126 82.8576 63.208 85.3834 53.1617 95.3594C48.3668 100.121 40.4552 106.36 40.4552 110.636C40.4552 114.913 40.4552 116.576 40.4552 116.576H110V45.1659H103.232C98.3811 45.1659 88.774 46.311 84.0048 41.565C79.2356 36.8189 78.9879 36.2511 72.8256 31.488C68.1718 27.891 55.428 28.16 52.7425 28.16C50.057 28.16 45.76 28.16 45.76 28.16Z'
        fill='#F8D2C2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M54.3516 44.0705C56.6665 45.4071 59.0356 45.6375 59.6431 44.5853C60.2507 43.533 58.8665 41.5965 56.5516 40.26C54.2366 38.9235 51.8675 38.693 51.26 39.7453C50.6525 40.7975 52.0366 42.734 54.3516 44.0705Z'
        fill='#ECC5B8'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M58.9486 35.9809V36.628L60.5349 35.6338C60.6632 35.5534 60.7412 35.4125 60.7412 35.261V32.6275C60.7412 31.8984 61.3322 31.3075 62.0612 31.3075C62.7902 31.3075 63.3812 31.8984 63.3812 32.6275V35.261C63.3812 36.3216 62.8355 37.3076 61.9368 37.8708L58.9486 39.7436V42.68C58.9486 43.409 58.3576 44 57.6286 44C56.8996 44 56.3086 43.409 56.3086 42.68V36.7002L53.3912 35.6759C52.5099 35.3665 51.92 34.5342 51.92 33.6001V31.6186C51.92 30.8896 52.511 30.2986 53.24 30.2986C53.969 30.2986 54.56 30.8896 54.56 31.6186V33.2883L56.3086 33.9022V26.84C56.3086 26.111 56.8996 25.52 57.6286 25.52C58.3576 25.52 58.9486 26.111 58.9486 26.84V35.5598C58.9709 35.697 58.9717 35.839 58.9486 35.9809Z'
        fill='#3B97BA'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear'
        x1='28.5001'
        y1='58.1734'
        x2='9.90083'
        y2='89.8186'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D6C7C7' />
        <stop offset='1' stopColor='#F8D2C2' />
      </linearGradient>
    </defs>
  </svg>
);
